// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.memberViewInfoTabOne {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
}
.memberViewInfoTabOne .headingDark {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-top: 32px;
  color: #333333;
  position: relative;
}
.memberViewInfoTabOne .headingWithSettings {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-top: 32px;
  color: #333333;
  position: relative;
  display: flex;
  align-content: center;
  margin-bottom: 12px;
}
.memberViewInfoTabOne .headingWithSettings .settingsWrapper {
  display: flex;
  align-items: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #505054;
}
.memberViewInfoTabOne .headingWithSettings .settingsWrapper .pencilImage {
  height: 18px;
  width: 18px;
}
.memberViewInfoTabOne .label {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  display: inline-block;
  margin-top: 10px;
  position: relative;
  width: 132px;
  text-align: left !important;
}
.memberViewInfoTabOne .headingDark-type2 {
  width: 132px;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  position: relative;
}
.memberViewInfoTabOne .value {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  display: inline-block;
}
.memberViewInfoTabOne .pillWrapper {
  display: flex;
  flex-direction: row;
}
.memberViewInfoTabOne .pillWrapper .pillContainerLabel {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  display: inline-block;
  margin-top: 10px;
  width: 132px;
  position: relative;
}
.memberViewInfoTabOne .pillWrapper .pillContainer {
  flex: 1 1;
  position: relative;
}
.memberViewInfoTabOne .accountInfo {
  margin-top: 48px;
}`, "",{"version":3,"sources":["webpack://./src/screens/viewInformation/tabOneView/tabOneView.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,kBAAA;AACJ;AAAI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAER;AAAI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAER;AAAQ;EACI,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAEZ;AAAY;EACI,YAAA;EACA,WAAA;AAEhB;AAII;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;AAFR;AAKI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAHR;AAMI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAJR;AAOI;EACQ,aAAA;EACA,mBAAA;AALZ;AAMQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAJZ;AAMQ;EACI,SAAA;EACA,kBAAA;AAJZ;AAQI;EACI,gBAAA;AANR","sourcesContent":[".memberViewInfoTabOne {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    .headingDark {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        margin-top: 32px;\n        color: #333333;\n        position: relative;\n    }\n    .headingWithSettings {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        margin-top: 32px;\n        color: #333333;\n        position: relative;\n        display: flex;\n        align-content: center;\n        margin-bottom: 12px;\n\n        .settingsWrapper {\n            display: flex;\n            align-items: center;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            color: #505054;\n\n            .pencilImage {\n                height: 18px;\n                width: 18px;\n            }\n        }\n    }\n\n    \n    .label {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #868686;\n        display: inline-block;\n        margin-top: 10px;\n        position: relative;\n        width: 132px;\n        text-align: left !important;\n    }\n \n    .headingDark-type2 {\n        width: 132px;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #333333;\n        position: relative;\n    }\n\n    .value {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #333333;\n        display: inline-block;\n    }\n\n    .pillWrapper { \n            display: flex;\n            flex-direction: row;\n        .pillContainerLabel {\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n            display: inline-block;\n            margin-top: 10px; \n            width: 132px; \n            position: relative;\n        }\n        .pillContainer {\n            flex: 1;\n            position: relative;\n        }\n    }\n\n    .accountInfo {\n        margin-top: 48px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
